export default __webpack_public_path__ + "static/media/13.9e6ee5f2.png";